  
import Users from './Users.vue'


export {Users} 


// WEBPACK FOOTER //
// ./src/pages/users/index.js